'use strict';

const validateVariant = require('../product/validateVarient');
const { getFormValidationMsgError } = require('../components/input');

const addDots = (text) => `${text.replace(/ /g, '').split('').join('.') + '.'}`;

/**
 * Update preview modal
 * @param {any} $modal - current modal
 */
function updatePersonalizationPreview($modal) {
    const $result = $('.js-personalization-text', $modal);
    const $checkedColor = $('.js-personalization-color:checked', $modal);
    const $colorLabelWrapper = $('.js-personalization-color-label-wrapper', $modal);
    const colorCSS = $('~ .color-label', $checkedColor).css('background-color');
    const colorID = $checkedColor.val();
    const colorLabel = $checkedColor.attr('data-label');
    const fontFamily = $('.js-personalization-font:checked', $modal).val();
    const dots = $('#personalizationDots', $modal).prop('checked');
    let position = $('.js-personalization-position:checked', $modal).attr('data-image-number') || '';
    const positionName = $('.js-personalization-position:checked', $modal).val();
    const $persoTextInput = $('#personalizationText', $modal);
    const $persoTextInputWrapper = $persoTextInput.closest('.js-text');
    const $labelTextSpan = $('label[for="personalizationText"] span', $modal);
    const $zoomImage = $('.js-zoom-image', $modal);
    const $nonZoomImage = $('.js-non-zoom-image', $modal);
    const lng = $modal.attr('data-lng');
    const isModal3D = !!$modal.attr('data-3d-url');
    let text = $persoTextInput.val() || '';
    const mapFont = {
        round: 'Round',
        rounded: 'Round',
        grotesk: 'Grotesk',
        grotesque: 'Grotesk',
        script: 'Script',
        grotesque_cursive: 'Grotesque Cursive',
        avant_garde: 'Avant Garde',
    };
    const mapColor = {
        blind: 'black',
    };

    if (text) {
        $zoomImage.removeClass('d-none');
        $nonZoomImage.addClass('d-none');
    } else {
        $zoomImage.addClass('d-none');
        $nonZoomImage.removeClass('d-none');
    }

    if ($persoTextInputWrapper.hasClass('js-force-uppercase')) {
        text = text.toUpperCase();
        $persoTextInput.val(text);
    }

    if (positionName === 'clip') {
        $persoTextInput.attr('maxlength', 3);
        text = text.slice(0, 3);
        $persoTextInput.val(text);
        $labelTextSpan.html('3');
        if (isModal3D) {
            position = 1;
        }
    } else if (positionName === 'cap') {
        $persoTextInput.attr('maxlength', 13);
        $labelTextSpan.html('13');
        if (isModal3D) {
            position = 2;
        }
    }

    if (dots) {
        text = lng.match(/jp/i) ? text.replace(/^(.){1}/, '$1.') : addDots(text);
    }
    if (position) {
        $('.js-personalization-preview-wrapper').addClass('d-none');
        $(`.js-personalization-preview-wrapper[data-image="${position}"]`).removeClass('d-none');
    }

    $colorLabelWrapper.html(colorLabel);

    let font = mapFont[fontFamily] || fontFamily || '';

    if (isModal3D) {
        $('body').trigger('productPersonalization:updateText', {
            $iframe: $('iframe', $modal),
            position,
            text,
            font,
            color: colorID ? colorID.toUpperCase() : '',
        });
    } else {
        $result.html(text);
        $result.css({
            color: mapColor[colorID] || colorCSS,
            fontFamily: font,
            textShadow: $modal.attr('data-personalization-type') === 'embossing' ? '1px 0px 3px grey' : 'initial',
        });
    }
}

/**
 * Load personalization modal
 * @param {string} url - url to call
 */
async function loadModal(url) {
    return new Promise((resolve, reject) => {
        $.ajax({
            url,
            method: 'GET',
            success: function (data) {
                if ($('#productPersonalizationModal').length > 0) {
                    $('#productPersonalizationModal').remove();
                }

                let $data = $(data); // Convert to jQuery object
                let layerData = $data.find('.js-datalayer-helper').val();
                // console.log('Layer Data:', layerData);
                if (layerData) {
                    $('body').trigger('gtm:add:event', { datalayer: JSON.parse(layerData) });
                }
                $('body').append(data);
                const $modal = $('#productPersonalizationModal');

                updatePersonalizationPreview($modal);
                $modal.modal('show');
                // handle message from web GL iframe
                window.addEventListener(
                    'message',
                    (event) => {
                        try {
                            let msgData = JSON.parse(event.data);
                            if (msgData.iframeStates === 'SUCCESS' || msgData.displayZoomTips === 'FALSE') {
                                setTimeout(function () {
                                    updatePersonalizationPreview($modal);
                                }, 3000);
                            }
                        } catch (e) {
                            return false;
                        }
                        return true;
                    },
                    false
                );

                return resolve();
            },
            error: function () {
                return reject();
            },
        });
    });
}

/**
 * submit form to server
 * @param {*} $this - form node element
 * @param {string} uuid - UUID pli cart
 */
function submitPersonalizationForm($this, uuid) {
    const $modal = $this.closest('#productPersonalizationModal');

    if (!$modal.length) {
        return;
    }

    let url = $this.attr('action');
    let oldvalue;
    if ($this.attr('data-valuebefore')) {
        oldvalue = $this.attr('data-valuebefore');
    } else {
        oldvalue = '';
    }

    if (uuid) {
        const currentUrl = new URL(url);
        currentUrl.searchParams.set('uuid', uuid);
        url = currentUrl.toString();
    }
    $.ajax({
        url,
        method: 'POST',
        data: $this.serialize() + '&oldvalue=' + oldvalue,
        success: function (response) {
            if (response.success && response.data) {
                const UUID = response.data.UUID;
                const persoData = response.personalizationData;
                const $context = $(`.js-lineitem-checkbox-wrapper[data-uuid="${UUID}"]`);
                const $input = $('.js-product-personalization-checkbox', $context);
                const $previewLineItem = $('.js-personalization-line-item-text', $context);
                $('.engraving-message-label').text(response.updateLabel);
                $input.prop('checked', true);
                $previewLineItem.html(persoData.dots ? addDots(persoData.text) : persoData.text);
                $previewLineItem.attr('data-font', persoData.font);

                $('body').trigger('gtm:add:event', response);
            }
            $modal.modal('hide');
        },
    });
}

module.exports = function () {
    if (!window.productPersonalizationLoaded) {
        $('body').on('click', '.js-open-personalization-modal', function (e) {
            e.preventDefault();
            const $this = $(this);
            const url = $this.attr('data-url');

            const formError = validateVariant.validate($this, $this);

            if (!formError) {
                loadModal(url);
            }
        });

        $('body').on('change', '.js-product-personalization-checkbox', function () {
            const $this = $(this);
            const url = $this.attr('data-url');
            const currentVal = $this.prop('checked');

            // undo the effect, wait for the modal submit/close to happen
            $this.prop('checked', !currentVal);

            loadModal(url);
        });

        $('body').on('click', '.js-edit-personalization', function (e) {
            e.preventDefault();
            $(this).closest('.js-lineitem-checkbox-wrapper').find('.js-product-personalization-checkbox').prop('checked', false).trigger('change');
        });

        $('body').on('change keyup', '#productPersonalizationModal input, #productPersonalizationModal select', function () {
            const $modal = $('#productPersonalizationModal');
            updatePersonalizationPreview($modal);
        });

        let isPersonalizationSubmitting = false;

        $('body').on('submit', '#productPersonalizationModal form', function (e) {
            e.preventDefault();
            const $form = $(this);

            const $personalizationInput = $form.find('#personalizationText');
            const errMsg = getFormValidationMsgError($personalizationInput[0]);

            // Show error if validation fails
            if (errMsg && errMsg.trim() !== '') {
                const $invalidFb = $personalizationInput.closest('.input-text-wrapper').find('.invalid-feedback');
                const $inputWrapper = $personalizationInput.closest('.input-field');
                const $customErrorText = $personalizationInput.closest('.form-element').find('.error-text.custom-error');

                $invalidFb.text(errMsg);
                $personalizationInput.addClass('is-invalid');
                $inputWrapper.removeClass('valid');
                $customErrorText.text(errMsg).removeClass('custom-error');
                return;
            }
            const uuid = $('#productPersonalizationModal').attr('data-uuid');
            if (uuid) {
                submitPersonalizationForm($form, uuid);
            } else {
                // eslint-disable-next-line no-lonely-if
                if (!isPersonalizationSubmitting) {
                    isPersonalizationSubmitting = true;
                    $('body').one('product:afterAddToCart', function (_, response) {
                        if (!response.pliUUID) {
                            $('#productPersonalizationModal').modal('hide');
                            return;
                        }

                        $('#productPersonalizationModal').attr('data-uuid', response.pliUUID);
                        submitPersonalizationForm($form, response.pliUUID);
                        isPersonalizationSubmitting = false;
                    });

                    const $variationOverlay = $('.variations-overlay');
                    let addToCartBtn;

                    if ($variationOverlay.hasClass('d-none')) {
                        addToCartBtn = $('.product-detail .prices-add-to-cart-actions button.add-to-cart:not(.sticky-add-to-cart)');
                    } else {
                        addToCartBtn = $variationOverlay.find('button.add-to-cart');
                    }

                    addToCartBtn.click();
                }
            }
        });

        $('body').on('product:afterAddToCart', function (_, response) {
            if (!response.pliUUID) {
                $('#productPersonalizationModal').modal('hide');
                return;
            }

            $('#productPersonalizationModal').attr('data-uuid', response.pliUUID);
            submitPersonalizationForm($('#productPersonalizationModal form'), response.pliUUID);
            isPersonalizationSubmitting = false;
        });

        $('body').on('product:personalizationSubmitting', function (e, { uuid }) {
            submitPersonalizationForm($('#productPersonalizationModal form'), uuid);
        });

        $('body').on('click', '#productPersonalizationModal .js-remove-personalization', function (e) {
            const $this = $(this);
            const $modal = $this.closest('#productPersonalizationModal');
            e.preventDefault();
            const url = $(this).attr('data-remove-url');

            $.ajax({
                url,
                method: 'POST',
                success: function (data) {
                    if (data.success) {
                        const $input = $(`.js-lineitem-checkbox-wrapper[data-uuid="${data.UUID}"] .js-product-personalization-checkbox`);
                        $input.prop('checked', false);
                        $modal.modal('hide');
                    }
                },
            });
        });
    }
    window.productPersonalizationLoaded = true;
};
